import createIcon from '../../createIcon';

/**
 * @component @name MoreTime
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41IDhWMTRMMTQuMiAxNi45TDE1IDE1LjdMMTEgMTMuM1Y4SDkuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNy40MiAxMkMxNy40NyAxMi4zMyAxNy41IDEyLjY2IDE3LjUgMTNDMTcuNSAxNi45IDE0LjQgMjAgMTAuNSAyMEM2LjYgMjAgMy41IDE2LjkgMy41IDEzQzMuNSA5LjEgNi42IDYgMTAuNSA2QzExLjIgNiAxMS44NyA2LjEgMTIuNSA2LjI5VjQuMjNDMTEuODYgNC4wOCAxMS4xOSA0IDEwLjUgNEM1LjUgNCAxLjUgOCAxLjUgMTNDMS41IDE4IDUuNSAyMiAxMC41IDIyQzE1LjUgMjIgMTkuNSAxOCAxOS41IDEzQzE5LjUgMTIuNjYgMTkuNDggMTIuMzMgMTkuNDQgMTJIMTcuNDJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTkuNSA1VjJIMTcuNVY1SDE0LjVWN0gxNy41VjEwSDE5LjVWN0gyMi41VjVIMTkuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MoreTime = createIcon('MoreTime', [
  ['path', { d: 'M9.5 8V14L14.2 16.9L15 15.7L11 13.3V8H9.5Z', key: '1rnj25' }],
  [
    'path',
    {
      d: 'M17.42 12C17.47 12.33 17.5 12.66 17.5 13C17.5 16.9 14.4 20 10.5 20C6.6 20 3.5 16.9 3.5 13C3.5 9.1 6.6 6 10.5 6C11.2 6 11.87 6.1 12.5 6.29V4.23C11.86 4.08 11.19 4 10.5 4C5.5 4 1.5 8 1.5 13C1.5 18 5.5 22 10.5 22C15.5 22 19.5 18 19.5 13C19.5 12.66 19.48 12.33 19.44 12H17.42Z',
      key: 'c5i7fs',
    },
  ],
  ['path', { d: 'M19.5 5V2H17.5V5H14.5V7H17.5V10H19.5V7H22.5V5H19.5Z', key: '1ycl91' }],
]);

export default MoreTime;
